export const filters = {
	searchPlaceholder: "Pesquisar produtos...",
	clearSearch: "Limpar pesquisa",
	allProducts: "Todos os produtos",
	activeProducts: "Produtos ativos",
	inactiveProducts: "Produtos inativos",
	viewByCategory: "Visualizar por Categoria",
	viewByMenuCategory: "Visualizar por Categoria de Menu",
	clearFilters: "Limpar filtros",
};
